import React from "react";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { Col, Row, Card } from "react-bootstrap";
import { images } from "../../../../constants";

const Farmming = ({ btn }) => {
  const farmingInfo = (
    <>
      <p>
        The <strong>Agriculture and Farming Market</strong> is a dedicated platform where users can search for <strong>farming-related products and services</strong>. It includes <strong>Business-to-Business (B2B)</strong> connectivity and <strong>Business-to-Consumer (B2C)</strong> connectivity.
      </p>
      <p>
        On this platform, users can find <strong>agricultural products, seeds, farming tools, machinery,</strong> and <strong>equipment</strong>. It connects farmers, suppliers, and agricultural businesses, making it easier to access essential resources for farming activities.
      </p>
      <p>
        The <strong>Agriculture and Farming Market</strong> supports efficient farming by providing <strong>multiple options, reliable suppliers,</strong> and <strong>easy product discovery</strong> in one place.
      </p>
      <a href="https://www.youtube.com" target="_blank">
        <strong>Click here to see how to Explore the Market</strong>
      </a>
    </>
  );

  return (
    <div>
      <Row>
        <Col lg="12">
          {/* CardNav displays title + full farming info */}
          <CardNav Header="Agriculture Markets" myid={1} myinfo={farmingInfo} />

          {/* BoxData for Farming Shop */}
          <Card className="shadow-main mt-2">
            <BoxData
              Title="Seeds & Tools"
              Butonn={btn}
              imgg={images.Farming}
              url="/farming-integrate"
              link="/Farming-online"
              ms="twentytwo-element"
              buy="twentyone"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Farmming;
